// Direktiva na renderovanie inline detailu zapasu
directives.eventDetailInlineDirective.eventDetailInline = function() {
    var directive = {
        "@class+": function() {
            if (this.Event.LiveFeedReference == -1) this.Event.LiveBetting = "N";

            // Zisti ci sa jedna o LIVE event
            offer.eventLive = this.Event.LiveBetting;

            // Ulozi LeagueCupID daneho eventu
            offer.eventLeagueCupID = this.Event.LeagueCupID;
        },
        "table@class+": function() {
            if (this.Event.LiveBettingView == -1 && !["notstarted", "nonstarted"].includes(this.Event.ActualGamePartID)) return " event-suspended";
        },
        "table thead .competitor-type-name": function() {
            switch (this.Event.RegionID) {
                case 1235:
                    // UOF Chrti
                    return texts.CompetitorTypeDog;
                    break;
                case 1236:
                    // UOF Kone
                    return texts.CompetitorTypeHorse;
                    break;
            }
        },
        "table thead .chance-type-label": {
            "columnLabel<-ColumnLabels": {
                ".chance-type-name": function() {
                    return this;
                }
            }
        },
        "table tbody tr": {
            "Row<-Competitors": {
                ".competitor-name@ID": function() {
                    return this.ID;
                },
                "td .competitor-name": function(a) {
                    var playerCell = "";
                    switch(a.context.Event.LeagueCupID) {
                        case 602577:
                            // UOF KONE
                            playerCell = "<img src='http://vhc20dev.aitcloud.de/vhcstaging/jersey/2003/" + this.odds[0].JockeyID + ".png' onerror='eventDetail.eventLogoError(this, true);'>";
                            break;
                        case 602578:
                            // UOF PSY
                            playerCell = "<img src='" + url.assetTeam + "greyhound-" + this.odds[0].TipType + ".png'>";
                            break;
                        case 600205: // BTX PSY
                        case 607003: // KRN KONE
                        case 607002: // KRN PSY
                        case 600204: // BTX Motokros
                        case 602349: // BTX Nascar
                           playerCell = virtual.assignCompetitorImage(this.odds[0].TipType, a.context.Event.Provider, a.context.Event.LeagueCupID);
                           break;
                        default:
                            break;
                    }
                    return playerCell += this.Name;
                },
                "td.cells": {
                    "odd<-Row.odds": {
                        "a@ID": "odd.OddsID",
                        "a@TipID": "odd.TipID",
                        "a@betType": function() {
                            if (this.BetType) return this.BetType;
                        },
                        "a@chanceTypeName": function() {
                            if (this.ChanceTypeName) return this.ChanceTypeName;
                        },
                        "a@tip-type": function() {
                            if (this.TipType) return this.TipType;
                        },
                        "a@competitorID": function() {
                            if (this.CompetitorID) return this.CompetitorID;
                        },
                        "a@onclick": function() {
                            return "ticket.ticketOddModule.ctAddOdd(" + this.OddsID + ", '" + this.BetType + "')";
                        },
                        "a@class+": function(a) {
                            var oddClass = "";
                            if (a.context.EventChanceTypes[this.EventChanceTypeID].EventChanceTypeStatus == "suspended") {
                                oddClass += "chanceType-suspended chanceType-hidden";
                            } else if (a.context.EventChanceTypes[this.EventChanceTypeID]) {
                                oddClass += "chanceType-" + this.EventChanceTypeStatus;
                            }
                            if (!this.OddsID) {
                                oddClass += " hide-odd";
                            } else {
                                if (ticket.listCheck(this.OddsID)) {
                                    oddClass += " ui-btn-up-e";
                                }
                            }
                            return oddClass;
                        },
                        "#crs": function() {
                            if (this.OddsRate) return this.OddsRate.toFixed(2);
                        },
                        "#crs@class": function () {
                            if (this.OddsRate <= 1) return "no-crs";
                        }
                    }
                }
            }
        }
    }
    if (offer.eventID && $("#M" + offer.eventID + " .event-detail-inline").length) {
        T.eventDetailInline = $p("#M" + offer.eventID + " .event-detail-inline").compile(directive);
    }
};
